import "./styles.scss";
import { ISidebarMenuProps } from './index';
import Logo from "../../../assets/common/logo.svg";
import { Multipass } from "multipass-js";
import { useState, useContext } from "react";
import { useEffect } from "react";
import { Context } from "../../../context";
import { MdPeople, MdMenu, MdClose, MdStore } from "react-icons/md";
import { userHasRole, Role, ROLE_SUPERUSER, ROLE_MERCHOLOGIST } from "@merchstores/admin/context/Roles";

export const MENU_ITEM_NONE = "none"
export const MENU_ITEM_GOT = "got_index"
export const MENU_ITEM_MERCHSTORES = "merchstores_index"

export const SidebarMenu = (props: ISidebarMenuProps) => {
    const MULTIPASS_SECRET = process.env.REACT_APP_MULTIPASS_SECRET;
    const SHOPIFY_STORE_URL = process.env.REACT_APP_SHOPIFY_STORE_URL;
    const isStaging = process.env.REACT_APP_ENV === 'staging';

    const { loginEmail, userRole, logoutUser } = useContext(Context);
    const [displaySidebar, setDisplaySidebar] = useState(false);
    const [activeItem, setActiveItem] = useState(MENU_ITEM_NONE);

    const hasMerchologistPermission = userHasRole(new Role(userRole), [ROLE_SUPERUSER, ROLE_MERCHOLOGIST]);
    
    useEffect(() => {
        if(window.location.pathname.toString().includes("/admin/group-orders")) {
                setActiveItem(MENU_ITEM_GOT)
        } else if(window.location.pathname.toString().includes("/admin/merchstores")) {
                setActiveItem(MENU_ITEM_MERCHSTORES)
        }
    })

    const toggleSidebarMenu = () => {
        setDisplaySidebar(!displaySidebar);
        if (props.onSidebarToggle) {
            props.onSidebarToggle(!displaySidebar);
        }
    }

    const goToMerchologySite = () => {
        const customerData = {
            email: loginEmail
        };
        const multipass = new Multipass(MULTIPASS_SECRET);
        const url = multipass.withCustomerData(customerData).withDomain(`${SHOPIFY_STORE_URL}`).withRedirect("/").url();
        window.open(url, '_blank');
    }

    return (
        <div className={`sidebarMenu ${displaySidebar ? 'active' : ''}`}>
            <div className='sidebarMenu-bars' onClick={toggleSidebarMenu}>
                <MdMenu />
            </div>
            <nav className={`${displaySidebar ? 'nav-menu active' : 'nav-menu'} relative`}>
                <div className="flex logo justify-center align-middle" onClick={goToMerchologySite}>
                    <img src={Logo} alt="Merchology Logo"></img>
                </div>
                <a href="/admin/group-orders" className={"flex mt-4 mb-6 " + (activeItem === MENU_ITEM_GOT ? "menu-item-active" : "")}>
                    <div className={"flex menu-item-icon justify-center items-center " + (activeItem === MENU_ITEM_GOT ? "active" : "")}>
                        <MdPeople size="24px"/>
                    </div>
                </a>
                {hasMerchologistPermission && isStaging &&
                    <a href="/admin/merchstores" className={"flex mt-4 mb-6 " + (activeItem === MENU_ITEM_MERCHSTORES ? "menu-item-active" : "")}>
                        <div className={"flex menu-item-icon justify-center items-center " + (activeItem === MENU_ITEM_MERCHSTORES ? "active" : "")}>
                            <MdStore size="24px"/>
                        </div>
                    </a>
                }
                <div className="closeButton" onClick={toggleSidebarMenu}>
                    <MdClose />
                </div>
                <div className="w-full flex justify-center absolute logout-link">
                    <a className="text-white text-10" href="javascript:void()" onClick={logoutUser}>Logout</a>
                </div>
            </nav>
        </div>
    )
}